import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Card,
  CardHeader,
  Col,
  Container,
  Input,
  Label,
  Row,
  Spinner
} from "reactstrap";
import { Editor } from "react-draft-wysiwyg";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML
} from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import { addBlog } from "store/actions/blogActions";
import { useDispatch } from "react-redux";
import { updateBlog } from "store/actions/blogActions";
import { toast } from "react-toastify";
import cross from "../../assets/img/cross.svg";
import { fetchBlogs } from "store/actions/blogActions";

const AddBlog = ({ setAddBlog, editingBlogId, setEditingBlogId }) => {
  const dispatch = useDispatch();
  let inputFile = useRef();
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [image, setImage] = useState(null);
  const [oldImage, setOldImage] = useState(null);
  const [btnLoader, setBtnLoader] = useState(false);

  useEffect(() => {
    if (editingBlogId) {
      const { description } = editingBlogId;
      const blocksFromHTML = convertFromHTML(description);
      const contentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      setEditorState(EditorState.createWithContent(contentState));
      setTitle(editingBlogId.title);
      setDescription(description);
      setImage(editingBlogId?.imageUrl ? editingBlogId?.imageUrl : "");
      setOldImage(editingBlogId?.imageUrl ? editingBlogId?.imageUrl : "");
      setCategory(editingBlogId?.category ? editingBlogId?.category : "");
    }
  }, [editingBlogId]);

  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
    const content = draftToHtml(convertToRaw(editorState.getCurrentContent()), {
      inlineStyles: true
    });
    setDescription(content);
  };

  const handleTitleChange = (event) => {
    setTitle(event.target.value);
  };

  const handleSubmit = () => {
    const descriptionContent = draftToHtml(
      convertToRaw(editorState.getCurrentContent())
    );
    setBtnLoader(true);

    if (editingBlogId) {
      const blog = {
        title: title,
        description: descriptionContent,
        category: category,
        image: image,
        oldImage: oldImage,
        id: editingBlogId.id,
        type: "admin"
      };
      if (title && !isDescriptionEmpty(descriptionContent) && category) {
        dispatch(
          updateBlog(blog, (res) => {
            setBtnLoader(false);
            if ((res = "success")) {
              setAddBlog(false);
              setEditingBlogId(null);
            }
          })
        );
      } else {
        setBtnLoader(false);
        toast.error("Please fill in all the required fields");
      }
    } else {
      const blog = {
        title: title,
        description: descriptionContent,
        category: category,
        image: image,
        type: "admin"
      };
      if (title && !isDescriptionEmpty(descriptionContent) && category) {
        dispatch(
          addBlog(blog, (res) => {
            setBtnLoader(false);
            if ((res = "success")) {
              setAddBlog(false);
              dispatch(fetchBlogs(""));
            }
          })
        );
      } else {
        setBtnLoader(false);
        toast.error("Please fill in all the required fields");
      }
    }
  };

  const handleImageChange = (e) => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
    }
  };

  const isDescriptionEmpty = (descriptionContent) => {
    const plainText = descriptionContent.replace(/<[^>]*>/g, "")?.trim();
    return plainText.length === 0;
  };

  return (
    <Container className="my-2" fluid>
      <Row>
        <div className="col">
          <Card className="shadow">
            <CardHeader>
              <Row>
                <Col xs={12} sm={6} md={4} className="mb-3 mb-md-0">
                  <Label className="mb-1">Title</Label>
                  <Input
                    type="text"
                    value={title}
                    onChange={handleTitleChange}
                    required
                  />
                </Col>
                <Col xs={12} sm={6} md={4} className="mb-3 mb-md-0">
                  <Label className="mb-1">Category</Label>
                  <Input
                    type="select"
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                    required
                  >
                    <option value="">Select a category</option>
                    <option value="News for Athlete">News for Athlete</option>
                    <option value="News for Fan">News for Fan</option>
                    <option value="News for Manager">News for Manager</option>
                  </Input>
                </Col>
                <Col
                  xs={12}
                  sm={12}
                  md={4}
                  className="mb-3 mb-md-0"
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                  }}
                >
                  <Label className="mb-3">Upload Image</Label>
                  <div className="d-flex">
                    <input
                      ref={inputFile}
                      type="file"
                      accept="image/png, image/gif, image/jpeg"
                      onChange={handleImageChange}
                      className="w-100"
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="mt-1 mt-md-3">
                  {image && (
                    <div className="position-relative">
                      <img
                        src={!image.name ? image : URL?.createObjectURL(image)}
                        alt="Selected"
                        width={50}
                        height={50}
                      />
                      <img
                        src={cross}
                        width={20}
                        alt=""
                        className="position-absolute"
                        style={{
                          top: "-23%",
                          left: "45px",
                          cursor: "pointer"
                        }}
                        onClick={() => {
                          setImage(null);
                          inputFile.current.value = "";
                        }}
                      />
                    </div>
                  )}
                </Col>
              </Row>
            </CardHeader>
            <div className="mx-4 my-2">
              <Editor
                editorState={editorState}
                toolbarClassName="toolbarClassName"
                wrapperClassName="wrapperClassName"
                editorClassName="editorClassName text-area"
                onEditorStateChange={onEditorStateChange}
                mention={{
                  separator: " ",
                  trigger: "@"
                }}
                toolbar={{
                  options: [
                    "inline",
                    "blockType",
                    "fontSize",
                    "fontFamily",
                    "list",
                    "textAlign",
                    "colorPicker",
                    "link",
                    "emoji",
                    "remove",
                    "history"
                  ],
                  inline: {
                    options: ["bold", "italic", "underline"]
                  },
                  blockType: {
                    options: ["Normal", "Blockquote", "Code"]
                  },
                  fontSize: {
                    options: [8, 10, 12, 14, 16, 18, 24, 30, 36, 48]
                  },
                  fontFamily: {
                    options: [
                      "Arial",
                      "Georgia",
                      "Impact",
                      "Tahoma",
                      "Times New Roman",
                      "Verdana"
                    ]
                  },
                  list: {
                    options: ["unordered", "ordered"]
                  },
                  textAlign: {
                    options: ["left", "center", "right"]
                  },
                  colorPicker: { disabled: false },
                  image: { disabled: true }, // Disable image option
                  link: { options: ["link"] },
                  remove: { options: ["remove"] },
                  history: { options: ["undo", "redo"] }
                }}
                required
              />
            </div>
            <div className="d-flex justify-content-end mx-4 mb-2">
              <Button
                className="mt-2 bg-primary text-white width-res"
                onClick={handleSubmit}
                disabled={btnLoader}
              >
                {btnLoader ? <Spinner size="sm" /> : "Save Changes"}
              </Button>
            </div>
          </Card>
        </div>
      </Row>
    </Container>
  );
};

export default AddBlog;
